import script from "./PracticeRecords.vue?vue&type=script&setup=true&lang=ts"
export * from "./PracticeRecords.vue?vue&type=script&setup=true&lang=ts"

import "./PracticeRecords.vue?vue&type=style&index=0&id=7a8f67f4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a8f67f4"]])

export default __exports__